/* SideDrawer — MUI Drawer wrapper (PS.drawer equivalent), anchored right.
   Paper carries `.supply-scope` so scoped CSS resolves inside the portal.

   props: open, onClose, title, children, footer(node), width (default 420). */
import React from 'react'
import PropTypes from 'prop-types'
import {Drawer, IconButton} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

export default function SideDrawer({open, onClose, title, children, footer, width = 420}) {
  return (
    <Drawer
      anchor='right'
      open={!!open}
      onClose={onClose}
      PaperProps={{
        className: 'supply-scope',
        sx: {
          bgcolor: '#fff',
          color: 'text.primary',
          width: typeof width === 'number' ? `${width}px` : width,
          maxWidth: '94vw',
        },
      }}
    >
      <div className='drawer-head'>
        <h3>{title}</h3>
        <IconButton className='iconbtn' onClick={onClose} aria-label='Close' size='small'>
          <CloseIcon fontSize='small' />
        </IconButton>
      </div>
      <div className='drawer-body'>{children}</div>
      {footer ? <div className='drawer-foot'>{footer}</div> : null}
    </Drawer>
  )
}

SideDrawer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.node,
  children: PropTypes.node,
  footer: PropTypes.node,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}
